var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dea5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e61c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3117",
    "data-name": "Rectangle 3117",
    width: 32,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14076",
    "data-name": "Group 14076",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13690",
    "data-name": "Group 13690",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13689",
    "data-name": "Group 13689",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13049",
    "data-name": "Path 13049",
    d: "M10.953,19.195l12.548,0a3.6,3.6,0,0,1,3.6,3.6v1.449A6,6,0,0,1,25.008,28.8C22.505,30.949,18.921,32,14.3,32l-.286,0a2.805,2.805,0,0,0-.354-3.035l-.178-.194L9.913,25.211A8.772,8.772,0,0,0,11.1,20.8a8.962,8.962,0,0,0-.144-1.6M14.3,0a8,8,0,1,1-8,8,8,8,0,0,1,8-8",
    transform: "translate(4.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13050",
    "data-name": "Path 13050",
    d: "M7.2,7.648a7.2,7.2,0,0,1,5.536,11.8l4.516,4.5a1.2,1.2,0,0,1-1.561,1.815l-.135-.116L10.91,21.02A7.2,7.2,0,1,1,7.2,7.648m0,2.4a4.8,4.8,0,1,0,4.8,4.8,4.8,4.8,0,0,0-4.8-4.8",
    transform: "translate(0 5.948)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSearch);
export default __webpack_public_path__ + "static/media/profileSearch.730ad404ccd3fbc203ef8d3a76e7a75a.svg";
export { ForwardRef as ReactComponent };